import React from "react";
import { RCCBadge, RCCHidden } from "react-common-components";
import { useHistory } from "react-router-dom";
import Title from "src/components/Title";
import WrapText from "src/components/WrapText";
import { useTranslation } from "src/context/Translations/context";
import { IDashboardProject } from "../interface";

interface ILI{
    data?: IDashboardProject;
}

const Li: React.FC<ILI> = ({
	data
}) => {
	const { translate } = useTranslation();

	const history = useHistory();

	if(!data)
		return <div></div>;

	return (
		<>
			<div>
				<Title color="purple" size="sm">
					<WrapText lineClamp={1}>
						{data.group && data.group !== "" ? data.group : translate("Sem setor")}
					</WrapText>
				</Title>
			</div>
			<div>
				<RCCBadge color="grey" layout="isSquare" onClick={ !data.groupId ? undefined :  () =>  
					history.push(`/projects/panel/?sector=${data.groupId ?? "0"}`)} >
					{data.count}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("Não iniciadas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="purple" layout="isSquare" >
					{data.notStarted}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("Não iniciadas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="blue" layout="isSquare">
					{data.inProgress}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("Em andamento")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="red" layout="isSquare">
					{data.delayed}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("Atrasadas")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="yellow" layout="isSquare"
				>
					{data.nextToExpire}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("A vencer")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="green" layout="isSquare">
					{data.finished}
				</RCCBadge>
				<RCCHidden mdUp>
					{translate("Concluídas")}
				</RCCHidden>
			</div>
		</>
	);
};

export default Li;
